import { useCertificateContext } from "../context/CertificateContext"
import CertificateAugmentationLayout from "../panel/CertificateAugmentationLayout"
import MultiSelect from "../text/MultiSelect"
import CertificateEditor from "./CertificateEditor"

const CertificateManager = () => {
  const { certificateScope } = useCertificateContext()
  return (
    <CertificateAugmentationLayout Primary={CertificateEditor}>
      {!certificateScope && <MultiSelect />}
    </CertificateAugmentationLayout>
  )
}

CertificateManager.displayName = "CertificateManager"

export default CertificateManager
